/* eslint-disable @typescript-eslint/no-unused-vars */
import { WebStorageStateStore } from "oidc-client-ts";
import { environment } from "./environment";
import jwt_decode from "jwt-decode";
import { ROLES, roleType } from "./shared/enums/role";
export function parseAuthInfo(authInfo) {
    var jwtInfo = jwt_decode(authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token);
    var role = getRole(jwtInfo.realm_access.roles);
    return {
        authenticated: true,
        currentRole: role,
        userName: (authInfo === null || authInfo === void 0 ? void 0 : authInfo.profile.preferred_username) || roleType.unauthorized,
        userToken: (authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token) || roleType.unauthorized,
        sessionId: (authInfo === null || authInfo === void 0 ? void 0 : authInfo.session_state) || roleType.unauthorized,
        userLoggin: (authInfo === null || authInfo === void 0 ? void 0 : authInfo.profile.email) || roleType.unauthorized,
        permissions: [],
    };
}
var onSigninCallback = function () {
    var _a;
    var prevUrl = (_a = AUTH_CONFIG.redirect_uri) === null || _a === void 0 ? void 0 : _a.replace(/[?].*/, "");
    window.location.replace(prevUrl || "");
};
export var AUTH_CONFIG = {
    authority: "".concat(environment.keyCloakConfig.url, "/realms/").concat(environment.keyCloakConfig.realm),
    client_id: environment.keyCloakConfig.clientId,
    post_logout_redirect_uri: window.location.href,
    redirect_uri: location.href,
    onSigninCallback: onSigninCallback,
    automaticSilentRenew: true,
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
};
var getRole = function (allRoles) {
    for (var _i = 0, allRoles_1 = allRoles; _i < allRoles_1.length; _i++) {
        var role = allRoles_1[_i];
        if (ROLES.includes(role))
            return role;
    }
    return roleType.unauthorized;
};
